import React from 'react';
import { Dropdown } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import { JdsMoreToggle } from '../../../../components/jds/JdsMoreToggle';
import { jdsMenuPopperConfig } from '../../../../components/jds/popper';

export function CouponRowActions({ coupon }) {
  const history = useHistory();

  const detailsHref = `/payments/coupons/${coupon.id}`;
  const editHref = `/payments/coupons/${coupon.id}/edit`;

  const navigate = (pathname) => (e) => {
    if (e.ctrlKey || e.metaKey || e.shiftKey || e.button === 1) return;
    e.preventDefault();
    history.push({ pathname, state: { coupon } });
  };

  return (
    <Dropdown alignRight>
      <Dropdown.Toggle
        as={JdsMoreToggle}
        variant="ghost"
        size="sm"
        id={`coupon-actions-${coupon.id}`}
        aria-label="Abrir opções do cupom"
      />
      <Dropdown.Menu
        className="dropdown-menu-sm"
        popperConfig={jdsMenuPopperConfig}
      >
        <Dropdown.Item
          href={detailsHref}
          onClick={navigate(detailsHref)}
          style={{ whiteSpace: 'normal' }}
        >
          Visualizar cupom
        </Dropdown.Item>
        <Dropdown.Item
          href={editHref}
          onClick={navigate(editHref)}
          style={{ whiteSpace: 'normal' }}
        >
          Editar cupom
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
}
